module.exports = __webpack_public_path__ + "static/media/compact-logo.b92bb9f6.png";